class GiftWrapForm extends HTMLElement {
  constructor() {
    super();

    // Reference to the elements
    this.button = this.querySelector('.gift-wrap-form__button');
    this.variantId = this.button.getAttribute('data-variant-id');
    this.button.addEventListener('click', () => this.addWrappingProduct());
  }

  addWrappingProduct() {
    console.log('click')
    console.log(this)


    // Add loading state to the button
    this.button.classList.add('loading');
    this.button.disabled = true;

    // Prepare data to send
    const data = {
      id: this.variantId,
      quantity: 1
    };

    // Use your existing function to add the item
    window.ShpCustom.Cart.addItemFromForm(data, () => {
      // Callback after item is added
      // Remove loading state from the button
      this.button.classList.remove('loading');
      this.button.disabled = false;

      // Update the cart UI or reload the page as needed
      // For example, you can update the mini cart
      if (window.location.href.includes('/cart')) {
        window.location.reload();
      } else {
        window.ShpCustom.Cart.getCart();
      }
    });
  }

}

// Register the custom element
customElements.define('gift-wrap-form', GiftWrapForm);
